export default [{
  path: '/tranformOrder',
  name: 'tranformOrder',
  meta: {
    index: 1
  },
  params:{},
  component: () => import('@/views/tranformOrder/index'),
}]
